import React from 'react';
import { DigitalSignRejection } from '../../components/contracts/financial-details/bank-account-section/edit-view/sepa-download-view/digital-sign-rejection/DigitalSignRejection';

export const DigitalSignErrorPage: React.FC = () => <DigitalSignRejection />;
